import React, { useState } from 'react';

const MONTHS = ['Januari','Februari','Mars','April','Maj','Juni','Juli','Augusti','September','Oktober','November','December'];
const DAYS = ['Mån','Tis','Ons','Tor','Fre','Lör','Sön'];

export default function BookingCalendar({ selected, onChange, allowedDates = null, disableSunday = true }) {
  const today = new Date(); today.setHours(0,0,0,0);
  const [year, setYear] = useState(today.getFullYear());
  const [month, setMonth] = useState(today.getMonth());

  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const firstDow = (new Date(year, month, 1).getDay() + 6) % 7;
  const cells = Array(firstDow).fill(null).concat(Array.from({length:daysInMonth},(_,i)=>i+1));
  const fmt = d => `${year}-${String(month+1).padStart(2,'0')}-${String(d).padStart(2,'0')}`;
  const isDisabled = d => {
    if (!d) return true;
    const dt = new Date(year, month, d); dt.setHours(0,0,0,0);
    if (dt < today) return true;
    if (disableSunday && new Date(year, month, d).getDay() === 0) return true;
    if (allowedDates && !allowedDates.includes(fmt(d))) return true;
    return false;
  };
  const prev = () => month === 0 ? (setYear(y=>y-1), setMonth(11)) : setMonth(m=>m-1);
  const next = () => month === 11 ? (setYear(y=>y+1), setMonth(0)) : setMonth(m=>m+1);

  return (
    <div className="border border-gray-200 rounded-xl overflow-hidden select-none">
      <div className="bg-red-600 text-white flex items-center justify-between px-4 py-3">
        <button type="button" onClick={prev} className="w-8 h-8 rounded-full bg-white/15 hover:bg-white/25 flex items-center justify-center text-lg font-bold transition-colors">‹</button>
        <span className="font-bold text-sm">{MONTHS[month]} {year}</span>
        <button type="button" onClick={next} className="w-8 h-8 rounded-full bg-white/15 hover:bg-white/25 flex items-center justify-center text-lg font-bold transition-colors">›</button>
      </div>
      <div className="grid grid-cols-7 bg-gray-50 border-b border-gray-100">
        {DAYS.map(d => <span key={d} className="text-center text-[10px] font-black uppercase tracking-wider text-gray-400 py-2">{d}</span>)}
      </div>
      <div className="grid grid-cols-7 p-2 gap-0.5 bg-white">
        {cells.map((d, i) => (
          <button key={i} type="button"
            disabled={isDisabled(d)}
            onClick={() => d && !isDisabled(d) && onChange(fmt(d))}
            className={`aspect-square rounded-full text-xs font-semibold flex items-center justify-center transition-colors mx-auto w-8 h-8
              ${!d ? 'invisible pointer-events-none' : ''}
              ${d && selected === fmt(d) ? 'bg-red-600 text-white' : ''}
              ${d && !isDisabled(d) && selected !== fmt(d) ? 'hover:bg-red-50 hover:text-red-600 text-gray-700 cursor-pointer' : ''}
              ${d && isDisabled(d) ? 'text-gray-200 cursor-not-allowed' : ''}
            `}>
            {d || ''}
          </button>
        ))}
      </div>
    </div>
  );
}
